/**
 * A piece of the open peek's own view state (the document's raw toggle, field filter and selected field; the
 * record's "how fresh"), kept in the URL beside `peek`. A switch (raw, a field, how fresh) is a history step counted
 * with the peek, so Back undoes it and closing the peek still goes back to where it was opened; typing the field
 * filter replaces the entry. usePeek clears these when another peek comes on top.
 */
import { useLocation } from 'react-router';
import { useSearchParams } from '../lib/liveparams.ts';
import { patchParams, readPeekCount } from '../lib/viewstate.ts';

export function usePeekParam(key: 'praw' | 'pf' | 'psel' | 'pfresh'): [string | null, (value: string | null) => void] {
  const [params, setParams] = useSearchParams();
  const { state } = useLocation();
  const count = readPeekCount(state);
  return [params.get(key), (value) => {
    if ((params.get(key) ?? null) === value) return;
    if (key === 'pf' || count === 0) setParams((p) => patchParams(p, { [key]: value }), { replace: true, state });
    else setParams((p) => patchParams(p, { [key]: value }), { state: { mvPeek: count + 1 } });
  }];
}
